import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StripeWrapper = styled.div`
  height: 100%;
  position: absolute;
  /*  position: fixed;

  height: 100vh;
  transform: translate3d(0, 0, 0);*/
  top: 0;
  left: 1.875rem;
  right: 1.875rem;
  color: ${props => props.color};
  pointer-events: none;
  line-height: 0;
  font-size: 0;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
    shape-rendering: crispedges;
    stroke: currentColor;
  }
`;

const BackgroundStripes = props => {
  const { breakpoint, color } = props;

  if (breakpoint === 'phone') return null;

  return (
    <StripeWrapper color={color}>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
        <line
          x1="25%"
          y="0"
          x2="25%"
          y2="100%"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <line
          x1="50%"
          y="0"
          x2="50%"
          y2="100%"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <line
          x1="75%"
          y="0"
          x2="75%"
          y2="100%"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </StripeWrapper>
  );
};

BackgroundStripes.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
  const { breakpoint } = state.layout;
  return {
    breakpoint,
  };
};

export default connect(mapStateToProps, null)(BackgroundStripes);



// WEBPACK FOOTER //
// ./src/modules/core/components/BackgroundStripes.js